import styled from 'styled-components';
import { Header1Text, Header3Text } from '../../../ui-toolkit';

export const PrimaryHeader = styled(Header1Text)`
  color: ${(props) => props.theme.colors.primary};
`;

export const PrimaryHeader3 = styled(Header3Text)`
  color: ${(props) => props.theme.colors.primary};
`;
